export enum DECISION_FILTERS {
  UNDECIDED = "UNDECIDED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELED = "CANCELED",
}

export enum APPROVAL_RECEIVE_TYPE {
  TO = "TO",
  CC = "CC",
}

export enum APPROVAL_DIRECTION {
  REQUESTING = "REQUESTING", // 요청한 결제
  REQUESTED = "REQUESTED", // 요청받은 결제
}
